import { createStore } from 'vuex'
//import { fetchAlarm } from '../modules/api'

const state = {
  currentPaneId: "",
  defaultPaneId: "radar",
  loading: false,
  panes: [
    {"value": "radar", "text":"降水预报"},
    {"value": "severe", "text": "强对流"},
    {"value": "alarm", "text": "国家预警"},
    {"value": "road", "text": "道路天气"},
    {"value": "roadcond", "text": "道路状态"},
  ],

  map: null
}

const mutations = {
  switchPane (state, payload) {
    state.currentPaneId = payload.paneId
    console.log("---------------------  currentPaneId is ", state.currentPaneId)
  },

  setMap (state, payload) {
    window.map = payload.map;
    state.map = payload.map
  },

  setLoading (state, payload) {
    state.loading = payload.loading
  }
}

const actions = {
  switchPane ({ commit }, payload) {
    commit('switchPane', payload)
  },

  setMap ({ commit }, payload) {
    commit('setMap', payload)
  },

  setLoading ({ commit }, payload) {
    commit('setLoading', payload)
  }

}

export default createStore({
  state,
  mutations,
  actions
})
